import { KernCAConfig } from "../../Redux/roStore";

export const MultiCardFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj?.MULT_CARD_ID?.Val === "Y";
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};
